<strong>Uma nova versão do Portugol Webstudio está disponível</strong>

@if (persistenceAvailable) {
  <p>O código das abas continua aqui depois de atualizar.</p>
} @else {
  <p>Seu navegador não está salvando o código: baixe seus arquivos antes de atualizar.</p>
}
<p>Quando estiver pronto, atualize a página ou use o botão abaixo.</p>

<div class="buttons">
  <button type="button" class="btn btn-primary btn-sm" (click)="onReload()">Atualizar</button>
  <button type="button" class="btn btn-ghost btn-sm" (click)="onIgnore()">Ignorar</button>
</div>
